import React from "react";
//#region types
import { CsvUploadStepProps } from "models/propTypes/customerImportPropTypes";
import { FileEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { FileUploaderProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { FileUploader, VerticalFormField, WizardSection } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CsvUploadStep: React.FC<CsvUploadStepProps> = ({ connect, submitted, wizardProps, setValues, resetForm }) => {
  const onFileUploaded = (value: UploadedFile[]) => {
    resetForm();
    wizardProps.resetWizard();
    setValues({ csvUpload: value });
  };

  const csvUploadProps = connect("csvUpload");

  return (
    <WizardSection
      header={TranslationKeys.Common.Upload}
      hasErrors={csvUploadProps.error}
      submitted={submitted}
      wizardProps={wizardProps}
      description={TranslationKeys.Customer.ImportFileSectionDescription}
    >
      <Grid container xs={6}>
        <VerticalFormField<FileUploaderProps>
          Component={FileUploader}
          singleSelection
          allowedTypes={[FileEnums.ContentTypes.CSV]}
          {...csvUploadProps}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.CSVFile)}
          showMainLabel
          setValue={onFileUploaded}
        />
      </Grid>
    </WizardSection>
  );
};

export default CsvUploadStep;
